import { render, staticRenderFns } from "./DropzonePlaceholder.vue?vue&type=template&id=2961d622&"
import script from "./DropzonePlaceholder.vue?vue&type=script&lang=js&"
export * from "./DropzonePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports